export default __webpack_public_path__ + "static/media/noaa.46832634.svg";